import { render, staticRenderFns } from "./setSys.vue?vue&type=template&id=26ab6d88"
import script from "./setSys.vue?vue&type=script&lang=js"
export * from "./setSys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26ab6d88')) {
      api.createRecord('26ab6d88', component.options)
    } else {
      api.reload('26ab6d88', component.options)
    }
    module.hot.accept("./setSys.vue?vue&type=template&id=26ab6d88", function () {
      api.rerender('26ab6d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/province/setSys.vue"
export default component.exports